import api from './api'

export const timeEntryService = {
  getActive: async () => {
    const response = await api.get('/time-entries/active')
    return response.data
  },

  start: async (taskId) => {
    const response = await api.post('/time-entries/start', { task_id: taskId })
    return response.data
  },

  stop: async (entryId, note = null) => {
    const response = await api.put(`/time-entries/${entryId}/stop`, { note })
    return response.data
  },

  createManual: async (data) => {
    const response = await api.post('/time-entries', data)
    return response.data
  },

  update: async (entryId, data) => {
    const response = await api.put(`/time-entries/${entryId}`, data)
    return response.data
  },

  delete: async (entryId) => {
    const response = await api.delete(`/time-entries/${entryId}`)
    return response.data
  },

  getProjectEntries: async (projectId, params = {}) => {
    const response = await api.get(`/projects/${projectId}/time-entries`, { params })
    return response.data
  },

  getTeamView: async (date) => {
    const response = await api.get('/time-entries/team-view', { params: { date } })
    return response.data
  },
}
